import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';

type VerifySignupInviteTokenResponse =
  | { valid: true; email: string }
  | { valid: false };

const fetcher = async (url: string): Promise<VerifySignupInviteTokenResponse> =>
  await denApi.get<VerifySignupInviteTokenResponse, void>(url);

export function useVerifySignupInviteToken(
  token: string | null,
  swrOptions?: SWRConfiguration<VerifySignupInviteTokenResponse>
) {
  const url = token ? `organization/invitations/verify/${token}` : null;
  const { data, error, isLoading, mutate } =
    useSWR<VerifySignupInviteTokenResponse>(url, fetcher, swrOptions);
  return {
    valid: data?.valid === true,
    email: data && data.valid === true ? data.email : undefined,
    isLoading,
    error,
    mutate,
  };
}
